import styled from "styled-components";
import { Flex } from "rebass/styled-components";

export const AllstarCmd = styled.span`
  color: ${({ theme }) => theme.colors.envy};
`;

export const AdContainer = styled(Flex)`
  justify-content: center;
  width: 100%;
  @media (min-width: 1500px) {
    display: none;
  }
`;
